import alertHandler from './alertHandler';
import commands from './commands/reducer';
import eps from './eps';
import epsList from './epsList';
import exemption from './exemption';
import exemptionList from './exemptionList';
import identity from './identity';
import identityList from './identityList';
import mailingRule from './mailingRule';
import mailingRuleList from './mailingRuleList';
import mainNavigation from './mainNavigation/reducer';
import mailingRuleByServiceCategoryList from './mailingRuleByServiceCategoryList';
import parameters from './parameters';
import permissionList from './permissionList';
import policy from './policy';
import policyList from './policyList';
import remunerationNavigation from './remunerationNavigation';
import remunerationSummary from './remunerationSummary';
import remunerationBonus from './remunerationBonus';
import remunerationBonusList from './remunerationBonusList';
import remunerationCommission from './remunerationCommission';
import remunerationCommissionList from './remunerationCommissionList';
import remunerationFixed from './remunerationFixed';
import remunerationFixedList from './remunerationFixedList';
import remunerationGoal from './remunerationGoal';
import remunerationGoalList from './remunerationGoalList';
import secLevel from './secLevel/reducer';
import settingsNavigation from './settingsNavigation';
import user from './user';
import epsNavigationMode from './epsNavigationMode';
import exemptionNavigationMode from './exemptionNavigationMode';
import mailingNavigationMode from './mailingNavigationMode';
import strategy from './strategy';
import strategyList from './strategyList';
import simulation from './simulation';
import simulationList from './simulationList';
import distributionContracts from './distributionContracts';
import selectedMailingRuleModeNavigation from './mailingRuleModeNavigation';
import resultNavigationMode from './resultNavigationMode';
import selectedStrategyModeNavigation from './strategyModeNavigation';
import selectedRemunerationModeNavigation from './remunerationModeNavigation/reducer';

const rootReducer = {
  alertHandler,
  commands,
  eps,
  epsList,
  exemption,
  exemptionList,
  identity,
  identityList,
  mailingNavigationMode,
  mailingRule,
  mailingRuleList,
  mainNavigation,
  mailingRuleByServiceCategoryList,
  parameters,
  permissionList,
  policy,
  policyList,
  remunerationNavigation,
  remunerationSummary,
  remunerationBonus,
  remunerationBonusList,
  remunerationCommission,
  remunerationCommissionList,
  remunerationFixed,
  remunerationFixedList,
  remunerationGoal,
  remunerationGoalList,
  secLevel,
  settingsNavigation,
  user,
  epsNavigationMode,
  exemptionNavigationMode,
  strategy,
  strategyList,
  simulation,
  simulationList,
  distributionContracts,
  selectedMailingRuleModeNavigation,
  resultNavigationMode,
  selectedStrategyModeNavigation,
  selectedRemunerationModeNavigation,
};

export default rootReducer;
